// extracted by mini-css-extract-plugin
export default {"page":"iw-z","landingBackground":"jw-z","nonLandingBackground":"kw-z"};